/**
 * Created on 16/8/19.
 */
export default {
    name: 'LEASE NOTES',
    description: '',
    rows: {
        'lease-notes': {
            value: ''
        }
    }
};